import React from "react";
import styles from "./UpcomingWorkshopCard.module.css";
import SubmitButton from "../Button/SubmitButton";
import Button from "../Button/Button";

const UpcomingWorkshopCard = ({ workshop, date, link }) => {
  const handleJoinNow = () => {
    window.open(link, "_blank");
  };
  return (
    <div className={styles.workshopRow}>
      <div className={styles.workshopName}>{workshop}</div>
      <div className={styles.workshopDate}>{date}</div>
      <div className={styles.workshopLink}>
        <Button
          text="Join Now"
          onClick={handleJoinNow}
          style={{
            backgroundColor: "#FF67A1",
            fontSize: "12px",
          }}
        />
      </div>
    </div>
  );
};

export default UpcomingWorkshopCard;
